import { useState, useEffect } from 'react'
import Header from './Header'
import Footer from './Footer'
import DireccionesShipping from './DireccionesShipping'
import DireccionFiscal from './DireccionFiscal'
import Slider from "react-slick";

function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    <button style={{"display":"none" }}
      className="next-slide slick-arrow js-next-slider"
      onClick={onClick}
    ><i className="fa fa-angle-right"></i></button>
  );
}

function SamplePrevArrow(props) {
  const {  onClick } = props;
  return (
    <button style={{"display":"none" }}
      className="prev-slide slick-arrow js-prev-slider"
      onClick={onClick}
    ><i className="fa fa-angle-left"></i></button>
  );
}

  var settings = {
                slidesToShow: 6,
                slidesToScroll: 6,
                speed: 900,
                autoplay: false,
                autoplaySpeed: 3500,
                dots: true,
                infinite: false,
                PrevArrow: window.$('.prev-despacho'),
                NextArrow:window.$('.next-despacho'),

			    nextArrow: <SampleNextArrow />,
			    prevArrow: <SamplePrevArrow />,

                responsive: [
                  {
                    breakpoint:930,
                    settings: {
                      slidesToShow: 5,
                      slidesToScroll: 1,
                    }
                  },
                  {
                    breakpoint:768,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3,
                      dots: false,
                      arrows: true,
                    }
                  } ,
                  {
                    breakpoint:480,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                      dots: false,
                      arrows: true,
                    }
                  }            
                ]
              };


const PageDespacho = ({user,validateproductos,itemshopping,resumen,removeProduct,subTotal,miproductos,expressActive,changeHasExpress,changeMethodShopping,methodShopping,loadMenu,loadTransversal,transversal,menus,myLazyLoad,myListCart,handleMiproductos,handleSubTotal, form}) =>{
	//const [miproductos, setMiproductos] = useState([])
	//const [resumen, setResumen] = useState([])
	//const [subTotal, setSubTotal] = useState("0.00")
	const [addressDefault, setAddressDefault] = useState(0)
	const [addressFiscal, setAddressFiscal] = useState(false)
	const [calendario, setCalendario] = useState([])
	const [shipping, setShipping] = useState("")
	const [despachoEcologico, setDespachoEcologico ] = useState(false)
	const [moreComment, setMoreComment ] = useState("")

	const handleChangeDespacho = (e) => {
		localStorage.reducirBolsa = "no";
		if (e.target.checked) {
			localStorage.reducirBolsa = "si";
		}
		setDespachoEcologico(e.target.checked)
	}

	const handleChangeMore = (e) => {
		setMoreComment(e.target.value)
		localStorage.moreComment = moreComment;
	}	

	
	const MantenerMisProductos = () =>{
		changeMethodShopping("schedule")
		window.$("#modalListOrdenPedido").modal("hide");
		getShipping(localStorage.distritoPay)
		myListCart()
	}

	const DeleteProductNoExpress = async() =>{
		var modaLoading = 
		window.Swal.fire({
			imageUrl: window.path_service+'/images/loading.png',
			title: 'Cargando datos...',
			showConfirmButton: false,
			customClass: 'ms-loading-modal',
			allowOutsideClick: false
		});

	    const dataq = new FormData();
	    dataq.append("action", "remove_product_no_express" );
	    const response_service = await fetch(window.path_service+"/api/remove_product_no_express", { method:'POST',body:  dataq })
	    const response = await response_service.json()

	    
		modaLoading.close();
	    window.$("#modalListOrdenPedido").modal("hide");
	    myListCart();

	}


const onClickprev = () =>{
	window.$(".js-prev-slider").click();

}

const selectedShipping = (e,item,group) =>{
	//console.log("methodShopping",shipping,"item",item,"group",group)
	
	window.$(".check-fresh").each(function(){
	    window.$(this)[0].checked = false;
	});
	e.target.checked = true
	var precio_envio = 0;
	if (methodShopping === "express") {
		if(
			resumen.free_shipping &&  resumen.hasOwnProperty("type_free_shipping") && 
			"tipo_dcto_dia" in resumen.type_free_shipping && resumen.type_free_shipping.tipo_dcto_dia && 
			"dia" in resumen.type_free_shipping && 
			parseInt(resumen.type_free_shipping.dia) === parseInt(calendario.express.num_dia)
		) {
			precio_envio = "0.00";
		}else{
			if (
				resumen.free_shipping &&
				"type_free_shipping" in resumen && 
				"tipo_dcto_dia" in resumen.type_free_shipping && 
				resumen.type_free_shipping.tipo_dcto_dia &&
				"dia" in resumen.type_free_shipping &&
				parseInt(resumen.type_free_shipping.dia) !== parseInt(calendario.express.num_dia)
				) {
				precio_envio = item.costo_envio;
			}else{
				
				if (resumen.free_shipping) {
					precio_envio = "0.00";
				}else{
					precio_envio = item.costo_envio;
				}

			}
		}
											

		const Payshipping = {
			date: item.fecha,
			dt: (item.fecha_parce_shipping+" "+item.horario),
			horario: item.horario,
			id: item.id_almacen_origen,
			price: precio_envio
		};
		localStorage.paymnet_shipping = JSON.stringify(Payshipping)
		myListCart()		
	}else if(shipping === "same_day"){
		const Payshipping = {
			id: 1,
			date: item.fecha,
			dt: (item.fecha_parce_shipping+" "+group.horario),
			horario: group.horario,
			price:group.costo_envio
		};
		localStorage.paymnet_shipping = JSON.stringify(Payshipping)
		myListCart()		
	}else{
		const Payshipping = {
			date: item.date,
			dt: (item.fecha_parce_shipping+" "+group.horario),
			horario: group.horario,
			id: group.id_horario,
			price:group.price
		};
		localStorage.paymnet_shipping = JSON.stringify(Payshipping)
		myListCart()		
	}
}

const onClicknext = () =>{
	window.$(".js-next-slider").click();
}

	const changeAddressDefaul = async (item) => {
		setAddressDefault(item.id_distrito_service)
		localStorage.distritoPay = item.id_distrito_service

        if( localStorage.methodshopping === "schedule" ) {
        	localStorage.comercioId = 1;
        }
		
		/*
		myListCart()
		getShipping(item.distrito_id)
		*/
		const responseCart = await myListCart()
		if (responseCart.success) {
			getShipping(item.distrito_id)
		}		
	}

	const changeAddressFiscalDefaul = (item) => {
		localStorage.facturacion = JSON.stringify(item)
	}

	const handleDocfactura = () =>{
		setAddressFiscal(document.getElementById("docfactura").checked)
		if (document.getElementById("docfactura").checked === false) {
			localStorage.removeItem("facturacion");
		}
	}
	
	useEffect(() => {
		if (form === "appdespacho") {
			window.$("body").addClass("fm-body-auth-mobile");	
			window.$("body").removeClass("fixed-top-init");			
			window.$(".fm-app-loading").remove();
		}		
//		list_cart();

		localStorage.removeItem("paymnet_shipping");
		localStorage.removeItem("reducirBolsa");
		localStorage.removeItem("moreComment");

		if (addressFiscal === false) {
			localStorage.removeItem("facturacion");
		}


	}, []);

	const nextPage = () =>{
		if (form === "appdespacho") {
			window.location.href = "/app/payment";
		}else{
			window.location.href = "/payment";
		}
	}

	const getShipping = async(id_distrito) =>{
		  if ( window.getCookie("commerce_lead_token") !== "" && window.getCookie("commerce_lead_token") !== undefined ) {
		    var myHeaders = new Headers();
		    myHeaders.append("Authorization", "Bearer "+ window.getCookie("commerce_lead_token") );				

		    const dataq = new FormData();
		    dataq.append("action", "get_shipping" );
		    dataq.append("idDistrito", id_distrito );
		    dataq.append("sub_total", subTotal );
		    dataq.append("address_default", localStorage.address );
		    dataq.append("comercio_id", localStorage.comercioId );
		    dataq.append("free_shipping", resumen.free_shipping );

		    if (localStorage.methodshopping === "express") {
		    	dataq.append("type_order", localStorage.methodshopping );
		    	dataq.append("same_day", "true" );
		    	
		    	const response = await fetch(window.path_service+"/api/list-shipping", { method:'POST',body:  dataq, headers: myHeaders })		    	
			    const data = await response.json()
				    if (data.success) {
				    	setCalendario({"express" : data})
				    	if( data.hasOwnProperty("express") &&  data.express ) {
				    		setShipping("express")
				    	}
				    }else{
				    	changeMethodShopping("schedule")
				    	getShipping(localStorage.distritoPay)

						window.Swal.fire({
						  title: 'Opps',
						  icon: 'error',
						  html: data.message,
						  showCloseButton: true,
						  showCancelButton: true,
						  focusConfirm: false,
						  confirmButtonText: `Ok`,
						   cancelButtonText: `Cancelar`,
						});
				    	//myListCart()
				    }
		    }else if (localStorage.methodshopping === "recojotienda") {
		    	alert("hola");	

		    }else{
		    	const response = await fetch(window.path_service+"/api/list-shipping-schedule", { method:'POST',body:  dataq, headers: myHeaders })
			    const data = await response.json()
			    if (data.status) {
			    	setCalendario(data)
			    	if (	(data.hasOwnProperty("no_same_day") &&  data.hasOwnProperty("same_day") ) || data.hasOwnProperty("same_day") ) {
			    		setShipping("same_day")
			    	}else{
			    		setShipping("no_same_day")
			    	}
			    }
		    }

		    
		
		  }
		
	}
	

	const changeViewShipping = (item) => {
		setShipping(item)
	}

	const fcCart = (page) =>{
		window.location.href = window.path_service + "/" + page;
	}

	return(
		<div>
	        <Header
	        	user = {user}
	        	myLazyLoad = {myLazyLoad}
	        	loadMenu = {loadMenu}
	        	loadTransversal = {loadTransversal}
	        	menus = {menus}
	        	transversal = {transversal}
	        	changeHasExpress = {changeHasExpress}
	        	changeMethodShopping = {changeMethodShopping}
	        	methodShopping = {methodShopping}
	        	expressActive = {expressActive}
		        subTotal = {subTotal}
		        miproductos = {miproductos}
		        list_cart = {myListCart}
		        handleMiproductos = {handleMiproductos}
		        handleSubTotal = {handleSubTotal}
		        removeProduct = {removeProduct}
	        />



<main  className="wrap-content page-interna" style={{ backgroundColor : "rgb(229, 229, 229)"}}>
  <div className="container-interna ms-payment ms-payment-despacho">
   <div className="ms-section">
    
    
      <div className="ms-payment-steps">
         <ul className="ms-content-steps js-steps-payment">
            <li className="item-step check" step="my-car">
               <div className="head-step">
                  <div className="icon-step" onClick={() => fcCart("carrito")}><i className="fa fa-shopping-cart"></i></div>
               </div>
               <div className="body-step">
                  <span>Mi Carrito</span>
               </div>
            </li>
            <li className="item-step active" step="my-despacho">
               <div className="head-step">
                  <div className="icon-step"><i className="fa fa-user"></i></div>
               </div>
               <div className="body-step">
                  <span>Despacho</span>
               </div>
            </li>
            <li className="item-step" step="my-payment">
               <div className="head-step">
                  <div className="icon-step"><i className="fa fa-credit-card"></i></div>
               </div>
               <div className="body-step">
                  <span>Metodo de pago</span>
               </div>
            </li>
            <li className="item-step" step="my-confirmacion">
               <div className="head-step">
                  <div className="icon-step"><i className="fa fa-file-text-o"></i></div>
               </div>
               <div className="body-step">
                  <span>Confirmación</span>
               </div>
            </li>
         </ul>
      </div>
      <div className="ms-wizard-wrapper eko-despacho  shop-despacho">
         <div className="ms-lateral-a">
            <div className="ms-wizard-item js-shopping-defined-address">
               <h3 className="ms-form-title">
                  <i className="fa fa-truck" aria-hidden="true"></i> Dirección de envío
               </h3>
               <div className="ms-tab-content">
                  <div className="ms-tab active js-list-default-address" id="activeaddres">
                  	<DireccionesShipping 
                  	visual="payment" 
                  	changeAddressDefaul = {changeAddressDefaul}
				    changeMethodShopping = {changeMethodShopping}
				    expressActive = {expressActive}                  	
                  	 />
                  </div>
               </div>
               
            </div>
            <div className="ms-wizard-item js-shopping-defined-invoice">
               <h3 className="ms-form-title">
                  <i className="fa fa-file-text" aria-hidden="true"></i> Facturación
               </h3>
               <div className="ms-form-description">
                  <p>Activa esta opción para solicitar factura.</p>
               </div>
               <div className="ms-checbox-swipe">
                  <input type="checkbox" name="swipe" id="docfactura" className="showhide js-checkout-factura" data-id="registerFactura" onClick={handleDocfactura} />
                  <label htmlFor="docfactura">Solicitar Factura
                  <span>
	                  <i className="fa fa-check" aria-hidden="true"></i>
	                  <i className="fa fa-times" aria-hidden="true"></i>
                  </span>
                  </label>
               </div>
               <div className="ms-tab-content">
                  {
                  	addressFiscal ? 
	                  <div className="ms-tab active" id="editinvoice">
	                     <DireccionFiscal visual="payment" changeAddressFiscalDefaul = {changeAddressFiscalDefaul} />
	                  </div>
	                  : null
                  }
               </div>
            </div>


            <div className="ms-wizard-item">
               <h3 className="ms-form-title"><i className="fa fa-list-alt" aria-hidden="true"></i> Datos complementarios</h3>
               <div className="ms-form-description">
                  <p>Despacho ecológico (mínimo uso de bolsa)</p>
               </div>
               <div className="ms-checbox-swipe">
                  <input onChange={handleChangeDespacho} type="checkbox" name="despachoEcologico" id="despachoEcologico" checked={despachoEcologico} />
                  <label htmlFor="despachoEcologico">
                  Si deseo reducir bolsas
                  <span>
                  	<i className="fa fa-check" aria-hidden="true"></i>
                  	<i className="fa fa-times" aria-hidden="true"></i>
                  </span>
                  </label>
               </div>
               
               <div className="ms-form-payment-register">
                  <div className="ms-item">
                    <label htmlFor="message">¿Te gustaría sugerirnos algún producto o tienes algún comentario?</label>
                    <textarea name="moreComment" id="moreComment" cols="30" rows="10" placeholder="por ejemplo, enviar la fruta madura." className="ms-input"
                    	value={moreComment}
                    	onChange={handleChangeMore}
                    ></textarea>
                  </div>
               </div>
            </div>            

            <div className="ms-wizard-item js-block-despacho">
            {
            	methodShopping === "express" ? 
            	<h3 className="ms-form-title js-title-despacho"><i className="fa fa-list" aria-hidden="true"></i> HORARIO DE DESPACHO EXPRESS</h3>
            	: 
            	<h3 className="ms-form-title js-title-despacho"><i className="fa fa-list" aria-hidden="true"></i> Escoge tu día ideal de entrega</h3>
            }               
               

               <ul className="js-list-tab-despacho">
               	{
               		"same_day" in calendario && "horarios" in calendario.same_day ? 
               		shipping === "same_day" ?
               			<li className="js-despacho-today active" data-type="especial" onClick={() => changeViewShipping("same_day")}>Para dia</li>
               			:
               			<li className="js-despacho-today" data-type="especial" onClick={() => changeViewShipping("same_day")}>Para dia</li>

               		: null
               	}          

               	{
               		"no_same_day" in calendario && "data" in calendario.no_same_day ? 
               			shipping === "no_same_day" ?
               				<li className="js-despacho-schedule active"  data-type="regular" onClick={() => changeViewShipping("no_same_day")}>Para mañana o siguientes días</li>
               				:
               				<li className="js-despacho-schedule"  data-type="regular" onClick={() => changeViewShipping("no_same_day")}>Para mañana o siguientes días</li>
               		: null
               	}

               </ul>
               <div className="block-pasos office-hours">
                  <div className="content-pasos">
		              

		              <div className="body-pasos regular active">
		                <div className="block-container-despacho">
		                  <div className="fm-body-despacho">
		                    <div className="fm-container-horario">
								<div className="fm-left-horario js-resumen-horario">
									<div className="fm-icon-carrito">
									    <img src="data:image/png;base64,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" alt="icono - carrito de despacho" />
									  </div>

									  <div className="fm-content-hora">
									  	{
									  		shipping === "express" && "express" in calendario  ?
						                          			<div className="fm-group-hora">
						                          				<div className="fm-hora">
						                          					<p className="hora">Despacho en menos de 60 minutos</p>
						                          				</div>
						                          			</div>			                          			
							            : null
							           }

									  	{
									  		shipping === "no_same_day" ?
		                          			"no_same_day" in calendario && "data" in calendario.no_same_day ?
		                          				(calendario.no_same_day.data.length > 0) ? 
		                          					calendario.no_same_day.data[0].group.map(
		                          						(gp,indexgp) => 
						                          			<div className="fm-group-hora" key={indexgp}>
						                          				<h4 className="title">{gp.nombre}</h4>
						                          				{
						                          					gp.data.map(
						                          					(gpdt,indexgpdt) =>
								                          				<div className="fm-hora" key={indexgpdt}>
								                          					<p className="hora">{gpdt.horario}</p>
								                          				</div>
						                          					)
						                          				}
						                          			</div>	
							                            )
							                    : null
							                :null
							            : null
							           }

									  	{
									  		shipping === "same_day" ?
		                          			"same_day" in calendario && "horarios" in calendario.same_day ?
		                          				(calendario.same_day.horarios.length > 0) ? 
		                          					<div className="fm-group-hora">
		                          					<h4 className="title">Rangos</h4>
		                          					{
		                          						calendario.same_day.horarios.map(
		                          							(gp,indexgp) => 
		                          								<div className="fm-hora" key={indexgp}>
		                          									<p className="hora">{gp.horario}</p>
		                          								</div>							                            
							                            )
		                          					}
							                       </div>
							                    : null
							                :null
							            : null
							           }

									  </div>
								</div>

		                      <div className="fm-right-horario">
		                        <div className="view-content">
		                          <div className="fm-container-arrows arrow-container-prev">
		                            <div className="fm-content-arrows">
		                              <div className="slick-arrow prev-despacho">
		                                <i className="fa fa-chevron-circle-left icon-arrow" aria-hidden="true" onClick={onClickprev}></i>
		                                <div className="prev-web" onClick={onClickprev}>Esta semana</div>
		                                <div className="prev-mobile" onClick={onClickprev}>Días previos</div>
		                              </div>
		                            </div>
		                          </div>

		                          <div className="js-resumen-horario-schedule" dir="ltr">

										{
										shipping === "express"  && "express" in calendario ? 
										<Slider className="slick-list slick-list-regular" {...settings}>
										   { "costo_envio" in calendario.express ?
										   <div>
										      <div className="fm-item-horario">
										         <div className="fm-content-dia">
										            <div className="freshmart-dia">
										               <h3>{calendario.express.nombre_dia}</h3>
										               <p className="fecha-web">{calendario.express.fecha_parce}</p>
										               <p className="fecha-mobile">{calendario.express.fecha_parce}.</p>
										            </div>
										            
										            <div className="freshmart-group-hour">
										            	<div className="freshmart-hour" >
										                  <div className="freshmart-info">
										                     <div className="content-checkbox">
										                        <label className="normal-checkbox">
										                           <input type="checkbox" className="check-fresh" name="hora" onClick={(e)=>selectedShipping(e,calendario.express,calendario.express) }  />
										                           <div className="check-btn"></div>
										                           <img className="img-checkbox" src="data:image/png;base64,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" alt="truck" />
										                        </label>
										                     </div>

										                     {
										                     	(
										                     		resumen.free_shipping && 
										                     		"type_free_shipping" in resumen && 
										                     		"tipo_dcto_dia" in resumen.type_free_shipping && 
										                     		resumen.type_free_shipping.tipo_dcto_dia && 
										                     		"dia" in resumen.type_free_shipping && 
										                     		parseInt(resumen.type_free_shipping.dia) === parseInt(calendario.express.num_dia)
										                     		) ?
										                     	<p className="precio">s/.0.00</p>
										                     		:
										                     			(
										                     				resumen.free_shipping &&
										                     				"type_free_shipping" in resumen && 
										                     				"tipo_dcto_dia" in resumen.type_free_shipping && 
										                     				resumen.type_free_shipping.tipo_dcto_dia &&
										                     				"dia" in resumen.type_free_shipping &&
										                     				parseInt(resumen.type_free_shipping.dia) !== parseInt(calendario.express.num_dia)
										                     			) ?
										                     				<p className="precio">s/. {calendario.express.costo_envio}</p>
										                     				:
										                     				resumen.free_shipping ? 
										                     					<p className="precio">s/.0.00</p>
										                     				:
										                     					<p className="precio">s/. {calendario.express.costo_envio}</p>
										                     }


										                     <div className="text-complete">
										                        <p className="completo">completo</p>
										                     </div>
										                  </div>
										                </div>
										            </div>

										        </div>
										    </div>
										</div>
										   : null
										   }
										</Slider>
										: null
										}

		                          	{
		                          		shipping === "no_same_day"  && "no_same_day" in calendario ? 
			                            
			                            <Slider className="slick-list slick-list-regular" {...settings}>

						                                {
						                                	"data" in calendario.no_same_day ?
							                                	calendario.no_same_day.data.map(
							                                	(item,indexday) =>
							                                		<div key={indexday}>
							                                			<div className="fm-item-horario">
							                                				<div className="fm-content-dia">
										                                        <div className="freshmart-dia">
										                                          <h3>{item.name}</h3>
										                                          <p className="fecha-web">{item.fecha_parce}</p>
										                                          <p className="fecha-mobile">{item.fecha_parce}.</p>
										                                        </div>	

										                                        {
										                                        	item.group.map(
										                                        	(gp,indexgp) =>
																						<div className="freshmart-group-hour" key={indexgp}>
																						   {
																						   	gp.data.map(
																						   	(dtitem,gpindexdt) =>
																							   <div className="freshmart-hour" key={gpindexdt}>
																							   	{
																							   		dtitem.status === 1 ? 
																								      <div className="freshmart-info">
																								         <div className="content-checkbox">
																								            <label className="normal-checkbox">
																								               <input type="checkbox" className="check-fresh" name="hora" onClick={(e)=>selectedShipping(e,item,dtitem) } />
																								               <div className="check-btn"></div>
																								               <img className="img-checkbox" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAeCAYAAABTwyyaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAKT2lDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVNnVFPpFj333vRCS4iAlEtvUhUIIFJCi4AUkSYqIQkQSoghodkVUcERRUUEG8igiAOOjoCMFVEsDIoK2AfkIaKOg6OIisr74Xuja9a89+bN/rXXPues852zzwfACAyWSDNRNYAMqUIeEeCDx8TG4eQuQIEKJHAAEAizZCFz/SMBAPh+PDwrIsAHvgABeNMLCADATZvAMByH/w/qQplcAYCEAcB0kThLCIAUAEB6jkKmAEBGAYCdmCZTAKAEAGDLY2LjAFAtAGAnf+bTAICd+Jl7AQBblCEVAaCRACATZYhEAGg7AKzPVopFAFgwABRmS8Q5ANgtADBJV2ZIALC3AMDOEAuyAAgMADBRiIUpAAR7AGDIIyN4AISZABRG8lc88SuuEOcqAAB4mbI8uSQ5RYFbCC1xB1dXLh4ozkkXKxQ2YQJhmkAuwnmZGTKBNA/g88wAAKCRFRHgg/P9eM4Ors7ONo62Dl8t6r8G/yJiYuP+5c+rcEAAAOF0ftH+LC+zGoA7BoBt/qIl7gRoXgugdfeLZrIPQLUAoOnaV/Nw+H48PEWhkLnZ2eXk5NhKxEJbYcpXff5nwl/AV/1s+X48/Pf14L7iJIEyXYFHBPjgwsz0TKUcz5IJhGLc5o9H/LcL//wd0yLESWK5WCoU41EScY5EmozzMqUiiUKSKcUl0v9k4t8s+wM+3zUAsGo+AXuRLahdYwP2SycQWHTA4vcAAPK7b8HUKAgDgGiD4c93/+8//UegJQCAZkmScQAAXkQkLlTKsz/HCAAARKCBKrBBG/TBGCzABhzBBdzBC/xgNoRCJMTCQhBCCmSAHHJgKayCQiiGzbAdKmAv1EAdNMBRaIaTcA4uwlW4Dj1wD/phCJ7BKLyBCQRByAgTYSHaiAFiilgjjggXmYX4IcFIBBKLJCDJiBRRIkuRNUgxUopUIFVIHfI9cgI5h1xGupE7yAAygvyGvEcxlIGyUT3UDLVDuag3GoRGogvQZHQxmo8WoJvQcrQaPYw2oefQq2gP2o8+Q8cwwOgYBzPEbDAuxsNCsTgsCZNjy7EirAyrxhqwVqwDu4n1Y8+xdwQSgUXACTYEd0IgYR5BSFhMWE7YSKggHCQ0EdoJNwkDhFHCJyKTqEu0JroR+cQYYjIxh1hILCPWEo8TLxB7iEPENyQSiUMyJ7mQAkmxpFTSEtJG0m5SI+ksqZs0SBojk8naZGuyBzmULCAryIXkneTD5DPkG+Qh8lsKnWJAcaT4U+IoUspqShnlEOU05QZlmDJBVaOaUt2ooVQRNY9aQq2htlKvUYeoEzR1mjnNgxZJS6WtopXTGmgXaPdpr+h0uhHdlR5Ol9BX0svpR+iX6AP0dwwNhhWDx4hnKBmbGAcYZxl3GK+YTKYZ04sZx1QwNzHrmOeZD5lvVVgqtip8FZHKCpVKlSaVGyovVKmqpqreqgtV81XLVI+pXlN9rkZVM1PjqQnUlqtVqp1Q61MbU2epO6iHqmeob1Q/pH5Z/YkGWcNMw09DpFGgsV/jvMYgC2MZs3gsIWsNq4Z1gTXEJrHN2Xx2KruY/R27iz2qqaE5QzNKM1ezUvOUZj8H45hx+Jx0TgnnKKeX836K3hTvKeIpG6Y0TLkxZVxrqpaXllirSKtRq0frvTau7aedpr1Fu1n7gQ5Bx0onXCdHZ4/OBZ3nU9lT3acKpxZNPTr1ri6qa6UbobtEd79up+6Ynr5egJ5Mb6feeb3n+hx9L/1U/W36p/VHDFgGswwkBtsMzhg8xTVxbzwdL8fb8VFDXcNAQ6VhlWGX4YSRudE8o9VGjUYPjGnGXOMk423GbcajJgYmISZLTepN7ppSTbmmKaY7TDtMx83MzaLN1pk1mz0x1zLnm+eb15vft2BaeFostqi2uGVJsuRaplnutrxuhVo5WaVYVVpds0atna0l1rutu6cRp7lOk06rntZnw7Dxtsm2qbcZsOXYBtuutm22fWFnYhdnt8Wuw+6TvZN9un2N/T0HDYfZDqsdWh1+c7RyFDpWOt6azpzuP33F9JbpL2dYzxDP2DPjthPLKcRpnVOb00dnF2e5c4PziIuJS4LLLpc+Lpsbxt3IveRKdPVxXeF60vWdm7Obwu2o26/uNu5p7ofcn8w0nymeWTNz0MPIQ+BR5dE/C5+VMGvfrH5PQ0+BZ7XnIy9jL5FXrdewt6V3qvdh7xc+9j5yn+M+4zw33jLeWV/MN8C3yLfLT8Nvnl+F30N/I/9k/3r/0QCngCUBZwOJgUGBWwL7+Hp8Ib+OPzrbZfay2e1BjKC5QRVBj4KtguXBrSFoyOyQrSH355jOkc5pDoVQfujW0Adh5mGLw34MJ4WHhVeGP45wiFga0TGXNXfR3ENz30T6RJZE3ptnMU85ry1KNSo+qi5qPNo3ujS6P8YuZlnM1VidWElsSxw5LiquNm5svt/87fOH4p3iC+N7F5gvyF1weaHOwvSFpxapLhIsOpZATIhOOJTwQRAqqBaMJfITdyWOCnnCHcJnIi/RNtGI2ENcKh5O8kgqTXqS7JG8NXkkxTOlLOW5hCepkLxMDUzdmzqeFpp2IG0yPTq9MYOSkZBxQqohTZO2Z+pn5mZ2y6xlhbL+xW6Lty8elQfJa7OQrAVZLQq2QqboVFoo1yoHsmdlV2a/zYnKOZarnivN7cyzytuQN5zvn//tEsIS4ZK2pYZLVy0dWOa9rGo5sjxxedsK4xUFK4ZWBqw8uIq2Km3VT6vtV5eufr0mek1rgV7ByoLBtQFr6wtVCuWFfevc1+1dT1gvWd+1YfqGnRs+FYmKrhTbF5cVf9go3HjlG4dvyr+Z3JS0qavEuWTPZtJm6ebeLZ5bDpaql+aXDm4N2dq0Dd9WtO319kXbL5fNKNu7g7ZDuaO/PLi8ZafJzs07P1SkVPRU+lQ27tLdtWHX+G7R7ht7vPY07NXbW7z3/T7JvttVAVVN1WbVZftJ+7P3P66Jqun4lvttXa1ObXHtxwPSA/0HIw6217nU1R3SPVRSj9Yr60cOxx++/p3vdy0NNg1VjZzG4iNwRHnk6fcJ3/ceDTradox7rOEH0x92HWcdL2pCmvKaRptTmvtbYlu6T8w+0dbq3nr8R9sfD5w0PFl5SvNUyWna6YLTk2fyz4ydlZ19fi753GDborZ752PO32oPb++6EHTh0kX/i+c7vDvOXPK4dPKy2+UTV7hXmq86X23qdOo8/pPTT8e7nLuarrlca7nuer21e2b36RueN87d9L158Rb/1tWeOT3dvfN6b/fF9/XfFt1+cif9zsu72Xcn7q28T7xf9EDtQdlD3YfVP1v+3Njv3H9qwHeg89HcR/cGhYPP/pH1jw9DBY+Zj8uGDYbrnjg+OTniP3L96fynQ89kzyaeF/6i/suuFxYvfvjV69fO0ZjRoZfyl5O/bXyl/erA6xmv28bCxh6+yXgzMV70VvvtwXfcdx3vo98PT+R8IH8o/2j5sfVT0Kf7kxmTk/8EA5jz/GMzLdsAAAAgY0hSTQAAeiUAAICDAAD5/wAAgOkAAHUwAADqYAAAOpgAABdvkl/FRgAAA6hJREFUeNrU2FuIVVUYB/DfXAorrWkKMgstH4SkosiSxG6QDPZQWaFWWyQKGqLaxabyIQt8KLC2tBEihB6ibT0YFaFG4S0sxJSUCCm7eAOtbNDKW46OvXwHDsc5o47jOPOHzdrn7LXX/q9vfZf/Wg1z82I/znHmsQRTav9MsrRXgzUH6f4g3tCXgzXrP1yEsbUTKPMCOrEnydLdJ22FuXlxuJ8sfiJ8gwVYkmRpx0Ai/ie+xUF0RduE83ExrsHleB8vJVm6a6C4yleYWi84y7wYjxwzcLDMi/YkS4/VG6yxH4kP6elhkqVrkeAnPIrbe+rfaAAhydKteA7n4ekyL5oGBfHAF5iPe3DLoCEefv1u/Jw6mCwOP2Mp2sq8GHG2iR8+BasfwmKMwQ1nO4//ix2n0P9CXInf8A7mx4QGXOXsCYewDjOTLN0ykH28uxpwGxaUeXHpYCJewd24r8yLhsaTWKI9ce07g4S6sB978Q/+66Hvi2ipp1X+xsZISWtxBFfjfkzEZX1E+Bi2YwVWY2dUzesxCdeipeadMRjfHfEtmI2F3cjOMojnPVW1k8Q+fIxZ3SjBTzGnzIuH8Aquq3k+pZb4r3gk5OfYkJnnhmX2hnW+ji3YYtx4GsQXIEuyVJkXwzEy5G0DjmJXkqUflXmxHoswrurdm6rT4X48G3r4ZczEqJpl/RJvYDnuwmcY2gvSf0Sg/YAJ4beTw0gV7IxVn4M7g1fFbTqqLb4Zn+CFWJ59WBnltyUqWBsuiUmtxbLw+1PFsnDJUXgNd0Sh2YjdGI2bg0tXkF8Xfg9Dq7PK3limZ8L6szAdT2Ja3C+NJZuOA1jVSzfZFN94IEivDi0+LcnSdjyM5yObtaM1JlpBU2NV1WzFVRiONXgvtlsVbIjgFMXAaaTIis6eEO2HSZauSbL0SGiVjnCTFbHJHl1T3ZubY7fRiN8jGOH7OqQqFm6pWvIZvSC+oWacld0Irc4IzAcxAm/HRKCrGR9U9b832gvqfLA2p26L63TPWlrqPB9W4ZNk6Xqsrydr91TSDa7oZqC2aLf2UQHaVjNu9XlLK26Nn3+dSI/vwHeRn2dX+eBwPBbX0UiHfYFVISuSMi+eKvNiZJAeF9+fGNnulxMdT2zHvMjVj8fW6UD0GxZnIAsjbfYFPo8k8ATexKtlXnRG2R8WGn4efjwuuie1Ta7VDpuj45DIs61xvymq3Vsxwb7AgQjUjvDzUVHQjkQgvo5FSZYet3v6fwCgCwo6rEtEIQAAAABJRU5ErkJggg==" alt="truck" />
																								            </label>
																								         </div>
																								         
																								         {
															                                    			(
															                                    			resumen.free_shipping &&
															                                    			"type_free_shipping" in resumen && 
															                                    			 "tipo_dcto_dia" in resumen.type_free_shipping && 
															                                    			 resumen.type_free_shipping.tipo_dcto_dia &&
															                                    			 "dia" in resumen.type_free_shipping &&
															                                    			  parseInt(resumen.type_free_shipping.dia) === parseInt(item.day)
															                                    			 ) ?
															                                    			 	<p className="precio">s/. 0.00</p>
															                                    			 :
																                                    			 (
																                                    			 	resumen.free_shipping &&
																                                    				"type_free_shipping" in resumen && 
																                                    			 	"tipo_dcto_dia" in resumen.type_free_shipping && 
																                                    			 	resumen.type_free_shipping.tipo_dcto_dia &&
																                                    			 	"dia" in resumen.type_free_shipping &&
																                                    			  	parseInt(resumen.type_free_shipping.dia) !== parseInt(item.day)
																                                    			 ) ?
																                                    			 	<p className="precio">s/. {dtitem.price}</p>
																                                    			 :
																                                    			 	resumen.free_shipping ? 
																                                    			 	<p className="precio">s/. 0.00</p>
																                                    			 :
																                                    			 <p className="precio">s/. {dtitem.price}</p>
																								         }


																									         <div className="text-complete">
																									            <p className="completo">completo</p>
																									         </div>
																								      </div>
																							   		:
																								      <div className="freshmart-info completado">
																								         <div className="content-checkbox">
																								            <label className="normal-checkbox">
																								               <input type="checkbox" className="check-fresh" name="hora" disabled />
																								               <div className="check-btn"></div>
																								               <img className="img-checkbox" src="data:image/png;base64,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" alt="truck" />
																								            </label>
																								         </div>																								         
																								         	<p className="precio">s/. {dtitem.price}</p>
																									         <div className="text-complete">
																									            <p className="completo">completo</p>
																									         </div>
																								      </div>
																							   	}																							      

																							   </div>
																						   	)
																						   }
																						</div>
										                                        	)
										                                        }





							                                				</div>
							                                			</div>
							                                		</div>
							                                	)
							                                : null
						                                }

			                        	</Slider>

			                            : null
			                        }

		                          	{
		                          		shipping === "same_day"  && "same_day" in calendario ? 
			                            
			                            <Slider className="slick-list-especial slick-initialized slick-slider" {...settings}>
						                                {
						                                	"horarios" in calendario.same_day ?
							                                		<div key="sameday" id="sameday">
							                                			<div className="fm-item-horario">
							                                				<div className="fm-content-dia">
										                                        <div className="freshmart-dia">
										                                          <h3>{calendario.same_day.nombre_dia}</h3>
										                                          <p className="fecha-web">{calendario.same_day.fecha_parce}</p>
										                                          <p className="fecha-mobile">{calendario.same_day.fecha_parce}.</p>
										                                        </div>	

																						<div className="freshmart-group-hour">
																						   {
																						   	calendario.same_day.horarios.map(
																						   	(dtitem,gpindexdt) =>
																							   <div className="freshmart-hour" key={gpindexdt}>
																							      <div className="freshmart-info">

																							         <div className="content-checkbox">
																							      {
																							      	dtitem.is_active ?
																							            <label className="normal-checkbox">
																							               <input type="checkbox" className="check-fresh" name="hora" onClick={(e)=>selectedShipping(e,calendario.same_day,dtitem) } />
																							               <div className="check-btn"></div>
																							               <img className="img-checkbox" src="data:image/png;base64,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" alt="truck" />
																							            </label>
																							      	:
																							            <label className="normal-checkbox">
																							               <img className="img-checkbox" src="data:image/png;base64,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" alt="truck" />
																							            </label>
																							      }


																							         </div>																					      

																							         {
																							         	dtitem.is_active ?

															                                    			(
															                                    			resumen.free_shipping &&
															                                    			"type_free_shipping" in resumen && 
															                                    			 "tipo_dcto_dia" in resumen.type_free_shipping && 
															                                    			 resumen.type_free_shipping.tipo_dcto_dia &&
															                                    			 "dia" in resumen.type_free_shipping &&
															                                    			  parseInt(resumen.type_free_shipping.dia) === parseInt(calendario.same_day.num_dia)
															                                    			 ) ?
															                                    			 	<p className="precio">s/. 0.00</p>
															                                    			 :
																                                    			 (
																                                    			 	resumen.free_shipping &&
																                                    				"type_free_shipping" in resumen && 
																                                    			 	"tipo_dcto_dia" in resumen.type_free_shipping && 
																                                    			 	resumen.type_free_shipping.tipo_dcto_dia &&
																                                    			 	"dia" in resumen.type_free_shipping &&
																                                    			  	parseInt(resumen.type_free_shipping.dia) !== parseInt(calendario.same_day.num_dia)
																                                    			 ) ?
																                                    			 	<p className="precio">s/. {dtitem.costo_envio}</p>
																                                    			 :
																                                    			 	resumen.free_shipping ? 
																                                    			 	<p className="precio">s/. 0.00</p>
																                                    			 :
																                                    			 <p className="precio">s/. {dtitem.costo_envio}</p>


																								         :
																								         <p className="precio"></p>

																							         }




																							      </div>
																							   </div>
																						   	)
																						   }
																						</div>





							                                				</div>
							                                			</div>
							                                		</div>
							                                	
							                                : null
						                                }

			                        	</Slider>

			                            : null
			                        }			                        
		                          </div>

		                          <div className="fm-container-arrows arrow-container-next">
		                            <div className="fm-content-arrows">
		                              <div className="slick-arrow next-despacho">
		                                <div className="next-web" onClick={onClicknext}>Proxima semana</div>
		                                <div className="next-mobile" onClick={onClicknext}>Proximos días</div>
		                                <i className="fa fa-chevron-circle-right icon-arrow" aria-hidden="true" onClick={onClicknext}></i>
		                              </div>
		                            </div>
		                          </div>
		                        </div>
		                      </div>
		                    </div>
		                  </div>
		                </div>
		                <div style={{display: "none"}} className="button-next-mobile item-form full-width"><button className="btn-form1">Continuar</button></div>
		              </div>   


                  </div>
               </div>

            </div>
         </div>

         <div className="ms-lateral-b ms-despacho">
            <div className="ms-wizard-item">
               <div className="ms-wrap-item">
                  <div className="ms-table-item" style={{"marginBottom": "0"}}>
                     <div className="ms-resumen-title">Resumen de la compra</div>
                     <div className="ms-scroll-table">
                        <table className="js-resumen-product-cart">
                        	<tbody>
		                        	{
		                        		"items" in resumen  && resumen.items.length > 0 ?
		                        				resumen.items.map((item,keyindex) =>

					                              <tr key = {keyindex}>
					                                 <td>
					                                    <div className="ms-item-product">
					                                       <div className="ms-wrap-img">
					                                          <img className="shop-lazy-image" alt={item.name} src={item.image} />
					                                       </div>
					                                       <div className="ms-wrap-detail">
					                                       		<p className="product-item__name">{item.name}</p>
					                                       		<div className="cantidad">({item.price_show} x {item.cantidad}) {item.unidadmedida} <span className="cant_tot_mon">S/. {item.total_sin_descuento}</span></div>

			                        							{
			                        								item.has_dsc_backo &&  item.descuentos.length > 0 ?
												                           			item.descuentos.map(
												                           				(descuento,index) =>
												                           				<div className="cantidad descuento-resumen">
												                           					{descuento.nombre_mostrar} <span className="cant_tot_mon">S/. {descuento.total_dcto}</span>
												                           				</div>
												                           			)								                           		
												                           	:null
							                        			}					                                            
					                                       </div>
					                                       
					                                       { item.has_express ?
					                                            <div className="icon-express">
					                                                <img src="/images/express.svg?1" className="img-express" alt="Freshmart" />
					                                            </div>
					                                            : null
					                                        }
					                                    </div>
					                                 </td>
					                              </tr>
					                            )
		                        		: null
			                        }
                        	</tbody>
                        </table>
                     </div>
                  </div>
                  <div className="ms-back-shipping">
                     <a href="#"><i className="fa fa-angle-left"></i> Volver al carrito</a>
                  </div>
                  <div className="ms-body-wizard">
			              <div className="ms-table-item js-cart-block-sub-total" style={{ marginBottom : "0"}}>

		                        <div className="ms-sub-title">
		                           <strong>Subtotal</strong>
		                           <strong className="color-price js-subtot-cart" mount="00.00">S/. {subTotal}</strong>
		                        </div>

		                        <table className="ms-payment-detail">
		                        	<tbody className="table-resumen">
		                        	{
		                        		"items" in resumen  && resumen.items.length > 0 ?
		                        		resumen.items.map((item,keyindex) =>
		                        			item.has_dsc_backo_tipo_2 &&
		                        			(
		                        				("producto" in item.descuentos) ||
		                        				("especial" in item.descuentos) 
		                        			)
		                        			 ?
			                        			<tr key = {keyindex} className="tr-rm-main">
			                        				{
			                        					Object.keys(item.descuentos).map(
			                        					(keyDesc, index) => 
			                        					keyDesc === "producto" || keyDesc === "especial" ?
			                        						item.descuentos[keyDesc].map(
				                        					(descpro, descindex) =>
				                        						descpro.tipo_adjustment === 2 ?
				                        						<tr className="tr-rm-main desc-cate" key={descindex}>
				                        							<td>
				                        								<div className="block-resumen resumen-descuento-prod" >
				                        									<span className="ms-grcolor">{descpro.nombre_mostrar}</span>
																			<span className="ms-pr-color">-S/{(descpro.monto_descuento) }</span>
																		</div>	
																	</td>	                        							
																</tr>
																: null
				                        					)
			                        						: null
			                        					)
			                        				}
			                        			</tr>
		                        			: null

		                        			)
		                        		: null
		                        	}
		                        	
		                        	{
		                        		"descuentos_productos" in resumen  ?
		                        				Object.keys(resumen.descuentos_productos).map(
		                        					(keyDesc, index) => 
		                        					resumen.descuentos_productos[keyDesc].map(
		                        						(descpro, descindex) =>
		                        						descpro.tipo_adjustment === 2 ?

		                        						<tr className="tr-rm-main desc-cate" key={descindex}>
		                        							<td>
		                        								<div className="block-resumen resumen-descuento-prod" >
		                        									<span className="ms-grcolor">{descpro.nombre_mostrar}</span>
		                        									<span className="ms-pr-color">-S/{(descpro.monto_a_descontar) }</span>
		                        								</div>	
		                        							</td>	                        							
		                        						</tr>
		                        						: null
		                        					)
		                        				)
			                        		
		                        		:
		                        		null
		                        	}


		                        				<tr className="tr-rm-main tr-sub-total">
		                        					<td>
		                        						<div className="block-resumen resumen-subtotal-prod" >
											            	<span className="ms-grcolor">Sub Total Productos</span>
											                <span className="ms-pr-color">S/{(resumen.total_descuentos_productos) }</span>
											            </div>	
											        </td>	                        							
											    </tr>


		                        	{
		                        		"infocupon" in resumen && "nombre_mostrar" in  resumen.infocupon && "tipo_adjustment" in  resumen.infocupon && resumen.infocupon.tipo_adjustment === "1" ?

		                        				<tr className="tr-rm-main">
		                        					<td>
		                        						<div className="block-resumen resumen-descuento-prod" >
											            	<span className="ms-grcolor">{resumen.infocupon.nombre_mostrar}</span>
											                <span className="ms-pr-color">-S/{(resumen.infocupon.monto_descuento) }</span>
											            </div>	
											        </td>	                        							
											    </tr>
		                        		:
		                        		null
		                        	}


		                        	{
		                        		"descuentos_globales" in resumen && "dia" in resumen.descuentos_globales ?
		                        				<tr className="tr-rm-main">
		                        					<td>
		                        						<div className="block-resumen resumen-descuento-prod" >
											            	<span className="ms-grcolor">{resumen.descuentos_globales.dia.nombre_mostrar}</span>
											                <span className="ms-pr-color">-S/{(resumen.descuentos_globales.dia.monto_a_descontar) }</span>
											            </div>	
											        </td>	                        							
											    </tr>
		                        		:
		                        		null
		                        	}

		                        	{
		                        		"descuentos_globales" in resumen && "distrito" in resumen.descuentos_globales ?
		                        				<tr className="tr-rm-main">
		                        					<td>
		                        						<div className="block-resumen resumen-descuento-prod" >
											            	<span className="ms-grcolor">{resumen.descuentos_globales.distrito.nombre_mostrar}</span>
											                <span className="ms-pr-color">-S/{(resumen.descuentos_globales.distrito.monto_a_descontar) }</span>
											            </div>	
											        </td>	                        							
											    </tr>
		                        		:
		                        		null
		                        	}


		                        	{
		                        		"descuentos_globales" in resumen && "orden" in resumen.descuentos_globales ?
		                        				<tr className="tr-rm-main">
		                        					<td>
		                        						<div className="block-resumen resumen-descuento-prod" >
											            	<span className="ms-grcolor">{resumen.descuentos_globales.orden.nombre_mostrar}</span>
											                <span className="ms-pr-color">-S/{(resumen.descuentos_globales.orden.monto_a_descontar) }</span>
											            </div>	
											        </td>	                        							
											    </tr>
		                        		:
		                        		null
		                        	}


	                              {
	                              	resumen.activeshippingprice ?
	                                  <tr className="tr-rm-main">
	                                    <td>
	                                    	<div className="block-resumen">
	                                    		<span className="ms-grcolor">Precio de envio</span>
	                                    		{
	                                    			resumen.free_shipping ? 
	                                    			<span className="ms-pr-color">S/0.00</span>
	                                    			:
	                                    			<span className="ms-pr-color">S/{ (resumen.shipping_price).toFixed(2) }</span>
	                                    		}
		                        				
		                        			</div>	                                    	
	                                    </td>
	                                  </tr>
	                                  : null
	                              }

                              {"dctoorden" in resumen && "nombre_mostrar" in resumen.dctoorden ? 
	                                  <tr className="tr-rm-main">
	                                    <td>
	                                    	<div className="block-resumen">
	                                    		<span className="ms-grcolor">{resumen.dctoorden.nombre_mostrar}</span>
		                        				<span className="ms-pr-color">-S/{resumen.dctoorden.monto_a_descontar}</span>
		                        			</div>	                                    	
	                                    </td>
	                                  </tr>
                                  :null
                              }  

                              {"activedescuentoCupon" in resumen && resumen.activedescuentoCupon ? 
	                                  <tr className="tr-rm-main">
	                                    <td>
	                                    {
	                                    	<div className="block-resumen">
		                                    	<span className="ms-grcolor">{resumen.nombrecupon}</span>
					                        	<span className="ms-pr-color">-S/{resumen.mountdescuento}</span>
					                        </div>	                                    	
	                                    }
	                                    </td>
	                                  </tr>
                                  :null
                              }                                            
			                    	</tbody>

			                        <tfoot  className="table-resumen" style={{"borderTop": "1px solid #ccc"}}>
			                            <tr className="tr-rm-main">
				                            <td>
	                                    	<div className="block-resumen">
	                                    		<span className="ms-grcolor foot"><strong>Total</strong></span>
		                        				<span className="ms-pr-color foot"><strong className="ms-grcolor">S/{resumen.totalPrice}</strong></span>
		                        			</div>	 
		                        			</td>
			                            </tr>
			                        </tfoot>                           
			                    </table>
		                           
		                           

		                        <span className="ms-min-text">Pedido mínimo de S/.35 para poder hacer una compra</span>
		                        { 
		                        	resumen.nextstep ? 
		                        	<button className="ms-btn green js-btn-next-payment" onClick={nextPage}>Continuar</button>
		                        	: null
		                        }
			              </div>                     
                  </div>
               </div>
            </div>
         </div>         
         

      </div>
   </div>
  </div>

  

</main>



	<div className="modal fade" id="modalListOrdenPedido" tabIndex="-1" role="dialog" aria-labelledby="modalListOrdenPedido">
	  <div className="modal-dialog" role="document">
	    <div className="modal-content">
	      <div className="modal-header">
	        <h3 className="ms-form-title">¿Estas comprando en modalidad Express y algunos productos NO SON EXPRESS?</h3>
	      </div>
			<div className="container-tabla">
			   <div className="campo-detalle">
				   <ul className="lista-detalle head">
				      <li className="fila-detalle">
				         <div className="item-detalle1"><span>SKU</span></div>
				         <div className="item-detalle2"></div>
				         <div className="item-detalle3">
				            <span>PRODUCTO</span>
				         </div>
				         <div className="item-detalle4"><span>PRECIO</span></div>
				         <div className="item-detalle5"><span>CANTIDAD</span></div>
				         <div className="item-detalle6"><span></span></div>
				         <div className="item-detalle7"><span>TOTAL</span></div>
				      </li>
				   </ul>			      
			   </div>
			   <ul className="lista-detalle">
			   {
			   	validateproductos.map(
			   		(product,index) =>
				    <li key = {index}  className="fila-detalle">
				         <div className="item-detalle1"><span>{product.sku}</span></div>
				         <div className="item-detalle2"></div>
				         <div className="item-detalle3"><p>{product.nombre}</p></div>
				         <div className="item-detalle4"><span>s/.{product.price}</span></div>
				         <div className="item-detalle5"><span>{product.cantidad}</span></div>
				         <div className="item-detalle6"><span></span></div>
				         <div className="item-detalle7"><span>s/.{product.total}</span></div>
				    </li>

			   	)
			   }
			   </ul>
			</div>
			<div className="content-buttons">
			   <div className="content-but">
			   		<div onClick={DeleteProductNoExpress}  className="button-agregar"><button type="button" className="btn-form1 btn-select">ELiminar productos No Express</button></div>
			   		<div onClick={MantenerMisProductos} className="button-agregar"><button type="button" className="btn-form1">Mantener mis productos</button></div>
			   </div>
			</div>



	    </div>
	  </div>
	</div>


	        <Footer />

		</div>
	)
}
export default PageDespacho;